import React, { memo } from 'react';

import dynamic from 'next/dynamic';

import { useFeatures } from '@atc/features';

import LazyComponent from '@/components/LazyComponent';

const PsxExplainerContainer = dynamic(() => import('./PsxExplainerContainer'), { ssr: false });
const PsxFraudContainer = dynamic(() => import('./PsxFraudContainer'), { ssr: false });
const SimilarInventoryContainer = dynamic(() => import('@/containers/vdp/SimilarInventoryContainer'), { ssr: false });

function PsxLowerDetails() {
    const {
        similar_inventory: [isSimilarInventoryEnabled],
    } = useFeatures([
        'similar_inventory',
    ]);

    return (
        <>
            <LazyComponent fallback={<div id="psx-faq" />}>
                <PsxExplainerContainer />
            </LazyComponent>
            {isSimilarInventoryEnabled && <LazyComponent><SimilarInventoryContainer /></LazyComponent>}
            <LazyComponent><PsxFraudContainer /></LazyComponent>
        </>
    );
}

export default memo(PsxLowerDetails);
